import React from 'react';

function Forecast({ weatherData }) {
  if (!weatherData || weatherData.length === 0) {
    return (
      <div className="forecast-panel">
        <h2 className="forecast-panel-title">7-Day Forecast</h2>
        <div className="no-location-message">
          <p>Select a location to view the forecast</p>
        </div>
      </div>
    );
  }

  return (
    <div className="forecast-panel">
      <h2 className="forecast-panel-title">7-Day Forecast</h2>
      
      <div className="forecast-list">
        {weatherData.map((period, i) => (
          <div key={i} className={`forecast-item ${period.isDaytime ? 'day' : 'night'}`}>
            <div className="forecast-item-header">
              <span className="forecast-period-name">{period.name}</span>
              <img src={period.icon} alt={period.shortForecast} className="forecast-weather-icon" />
            </div>
            <div className="forecast-temp-display">
              <span className="forecast-temp-value">{period.temperature}°</span>
              <span className="forecast-temp-unit">{period.temperatureUnit}</span>
            </div>
            <p className="forecast-short-desc">{period.shortForecast}</p>
            <hr className="forecast-divider" />
            <p className="forecast-detailed-desc">{period.detailedForecast}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Forecast;
